module.exports = __webpack_public_path__ + "static/img/SM@2x.1a66b931.png";